import { render } from "./NavigationView.vue?vue&type=template&id=32c20bdf&scoped=true"
import script from "./NavigationView.vue?vue&type=script&lang=js"
export * from "./NavigationView.vue?vue&type=script&lang=js"

import "./NavigationView.vue?vue&type=style&index=0&id=32c20bdf&scoped=true&lang=css"

import exportComponent from "E:\\Work\\GPTWeb\\licCode\\lic\\webviewer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32c20bdf"]])

export default __exports__